import React, { Component } from 'react';
import {Form} from 'react-bootstrap';
import { translate } from "react-i18next";
import { Link } from 'react-router-dom';



  
class AgbCheck extends Component {

    render(){
        const { t } = this.props;
        return (
            <Form inline>
               <Form.Check className="float-right"  name="commentsEnabled" id="commentsEnabled" onChange={ this.props.handleAgbCheckbox} />
                  {t("agb1")}&nbsp;
                <Link to={"/agb"} target="_blank">{t("agbLink")}</Link>&nbsp;
                {t("agb2")}
            </Form>
        );
    }
}

export default translate("translations")(AgbCheck);